import React from 'react';
import { Users } from 'lucide-react';

const UsersPlannedStep = ({ value, onChange }) => {
  const options = [
    { 
      label: '1–99 users', 
      value: '1-99',
      description: 'Starter Teams',
      price: '$20/user/month'
    },
    { 
      label: '100–499 users', 
      value: '100-499',
      description: 'Scaling Organizations',
      price: '$15/user/month'
    },
    { 
      label: '500+ users', 
      value: '500+',
      description: 'Enterprise',
      price: 'Custom pricing'
    },
  ];

  return (
    <div>
      <div className="flex items-center gap-3 mb-2">
        <Users className="w-6 h-6 text-cyan-400" />
        <h3 className="text-2xl font-bold text-white">How many users will you have?</h3>
      </div>
      <p className="text-gray-400 mb-6">This determines your pricing tier</p>
      <div className="space-y-3">
        {options.map((option) => (
          <button
            key={option.value}
            onClick={() => onChange(option.value)}
            data-testid={`users-option-${option.value}`}
            className={`w-full text-left p-5 rounded-xl border-2 transition-all duration-200 ${
              value === option.value
                ? 'border-cyan-500 bg-cyan-600/20 text-white'
                : 'border-gray-600 hover:border-gray-500 text-gray-300 hover:bg-gray-800/50'
            }`}
          >
            <div className="flex justify-between items-center">
              <div>
                <div className="font-semibold text-lg">{option.label}</div>
                <div className="text-sm text-gray-400">{option.description}</div>
              </div>
              <div className={`text-right ${value === option.value ? 'text-cyan-400' : 'text-gray-500'}`}>
                <div className="font-bold">{option.price}</div>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default UsersPlannedStep;
